import React from 'react';
import RichTextEditor from './RichTextEditor';

function AboutEditor({ pageContent, setPageContent, uploading, uploadingField, handleImageUpload, deleteImageFromFirebase }) {
  return (
    <div className="page-editor">
      <div className="editor-card">
        <h3>📖 About Page</h3>
        <div className="form-group">
          <label>Page Title</label>
          <input value={pageContent.title || 'About Us'} onChange={(e) => setPageContent({...pageContent, title: e.target.value})} className="form-input" />
        </div>
        
        <div className="form-group">
          <label>School History (Rich Text)</label>
          <RichTextEditor 
            value={pageContent.history || ''}
            onChange={(html) => setPageContent({...pageContent, history: html})}
            placeholder="Write about the school's history, founding, milestones..."
            imageFolder="about-history-images"
          />
        </div>
        
        <div className="form-group">
          <label>Mission (Rich Text)</label>
          <RichTextEditor 
            value={pageContent.mission || ''}
            onChange={(html) => setPageContent({...pageContent, mission: html})}
            placeholder="School's mission statement..."
            imageFolder="about-mission-images"
          />
        </div>
        
        <div className="form-group">
          <label>Vision (Rich Text)</label>
          <RichTextEditor 
            value={pageContent.vision || ''}
            onChange={(html) => setPageContent({...pageContent, vision: html})}
            placeholder="School's vision statement..."
            imageFolder="about-vision-images"
          />
        </div>
        
        <div className="form-group">
          <label>Philosophy (Rich Text)</label>
          <RichTextEditor 
            value={pageContent.philosophy || ''}
            onChange={(html) => setPageContent({...pageContent, philosophy: html})}
            placeholder="School's educational philosophy..."
            imageFolder="about-philosophy-images"
          />
        </div>

        <h4>📚 Academic Information</h4>
        <div className="form-group">
          <label>Curriculum Information (Rich Text)</label>
          <RichTextEditor 
            value={pageContent.curriculum || ''}
            onChange={(html) => setPageContent({...pageContent, curriculum: html})}
            placeholder="Information about the curriculum..."
            imageFolder="about-curriculum-images"
          />
        </div>
        
        <div className="form-group">
          <label>Academic Programs (Rich Text)</label>
          <RichTextEditor 
            value={pageContent.academicPrograms || ''}
            onChange={(html) => setPageContent({...pageContent, academicPrograms: html})}
            placeholder="List of academic programs offered..."
            imageFolder="about-programs-images"
          />
        </div>
        
        <h4>👨‍🏫 Principal's Desk</h4>
        <div className="form-group">
          <label>Principal Name</label>
          <input value={pageContent.principalName || ''} onChange={(e) => setPageContent({...pageContent, principalName: e.target.value})} className="form-input" />
        </div>
        <div className="form-group">
          <label>Principal Photo</label>
          {pageContent.principalPhoto && <img src={pageContent.principalPhoto} className="preview-img" />}
          <div style={{display: 'flex', gap: 10, marginTop: 8}}>
            <label className="upload-label">{uploading && uploadingField === 'principalPhoto' ? '⏳...' : '📷 Upload Photo'}<input type="file" accept="image/*" style={{display:'none'}} onChange={(e) => { if (e.target.files[0]) handleImageUpload('principalPhoto', e.target.files[0]); }} /></label>
            {pageContent.principalPhoto && <button className="remove-btn" onClick={() => deleteImageFromFirebase(pageContent.principalPhoto, 'principalPhoto', false)}>🗑️ Delete</button>}
          </div>
        </div>
        <div className="form-group">
          <label>Principal Message (Rich Text)</label>
          <RichTextEditor 
            value={pageContent.principalMessage || ''}
            onChange={(html) => setPageContent({...pageContent, principalMessage: html})}
            placeholder="Write a message from the Principal..."
            imageFolder="principal-message-images"
          />
        </div>

        <h4>👩‍💼 Director's Desk</h4>
        <div className="form-group">
          <label>Director Name</label>
          <input value={pageContent.directorName || ''} onChange={(e) => setPageContent({...pageContent, directorName: e.target.value})} className="form-input" />
        </div>
        <div className="form-group">
          <label>Director Photo</label>
          {pageContent.directorPhoto && <img src={pageContent.directorPhoto} className="preview-img" />}
          <div style={{display: 'flex', gap: 10, marginTop: 8}}>
            <label className="upload-label">{uploading && uploadingField === 'directorPhoto' ? '⏳...' : '📷 Upload Photo'}<input type="file" accept="image/*" style={{display:'none'}} onChange={(e) => { if (e.target.files[0]) handleImageUpload('directorPhoto', e.target.files[0]); }} /></label>
            {pageContent.directorPhoto && <button className="remove-btn" onClick={() => deleteImageFromFirebase(pageContent.directorPhoto, 'directorPhoto', false)}>🗑️ Delete</button>}
          </div>
        </div>
        <div className="form-group">
          <label>Director Message (Rich Text)</label>
          <RichTextEditor 
            value={pageContent.directorMessage || ''}
            onChange={(html) => setPageContent({...pageContent, directorMessage: html})}
            placeholder="Write a message from the Director..."
            imageFolder="director-message-images"
          />
        </div>

        <h4>👩‍🏫 Headmistress's Desk</h4>
        <div className="form-group">
          <label>Headmistress Name</label>
          <input value={pageContent.headmistressName || ''} onChange={(e) => setPageContent({...pageContent, headmistressName: e.target.value})} className="form-input" />
        </div>
        <div className="form-group">
          <label>Headmistress Photo</label>
          {pageContent.headmistressPhoto && <img src={pageContent.headmistressPhoto} className="preview-img" />}
          <div style={{display: 'flex', gap: 10, marginTop: 8}}>
            <label className="upload-label">{uploading && uploadingField === 'headmistressPhoto' ? '⏳...' : '📷 Upload Photo'}<input type="file" accept="image/*" style={{display:'none'}} onChange={(e) => { if (e.target.files[0]) handleImageUpload('headmistressPhoto', e.target.files[0]); }} /></label>
            {pageContent.headmistressPhoto && <button className="remove-btn" onClick={() => deleteImageFromFirebase(pageContent.headmistressPhoto, 'headmistressPhoto', false)}>🗑️ Delete</button>}
          </div>
        </div>
        <div className="form-group">
          <label>Headmistress Message (Rich Text)</label>
          <RichTextEditor 
            value={pageContent.headmistressMessage || ''}
            onChange={(html) => setPageContent({...pageContent, headmistressMessage: html})}
            placeholder="Write a message from the Headmistress..."
            imageFolder="headmistress-message-images"
          />
        </div>

        <h4>🎓 Other Staff (Optional)</h4>
        <div className="form-group">
          <label>Vice Principal Name</label>
          <input value={pageContent.vicePrincipalName || ''} onChange={(e) => setPageContent({...pageContent, vicePrincipalName: e.target.value})} className="form-input" />
        </div>
        <div className="form-group">
          <label>Vice Principal Photo</label>
          {pageContent.vicePrincipalPhoto && <img src={pageContent.vicePrincipalPhoto} className="preview-img" />}
          <div style={{display: 'flex', gap: 10, marginTop: 8}}>
            <label className="upload-label">{uploading && uploadingField === 'vicePrincipalPhoto' ? '⏳...' : '📷 Upload Photo'}<input type="file" accept="image/*" style={{display:'none'}} onChange={(e) => { if (e.target.files[0]) handleImageUpload('vicePrincipalPhoto', e.target.files[0]); }} /></label>
            {pageContent.vicePrincipalPhoto && <button className="remove-btn" onClick={() => deleteImageFromFirebase(pageContent.vicePrincipalPhoto, 'vicePrincipalPhoto', false)}>🗑️ Delete</button>}
          </div>
        </div>
        <div className="form-group">
          <label>Vice Principal Message (Rich Text)</label>
          <RichTextEditor 
            value={pageContent.vicePrincipalMessage || ''}
            onChange={(html) => setPageContent({...pageContent, vicePrincipalMessage: html})}
            placeholder="Write a message from the Vice Principal..."
            imageFolder="viceprincipal-message-images"
          />
        </div>

        <div className="form-group">
          <label>Dean Name</label>
          <input value={pageContent.deanName || ''} onChange={(e) => setPageContent({...pageContent, deanName: e.target.value})} className="form-input" />
        </div>
        <div className="form-group">
          <label>Dean Photo</label>
          {pageContent.deanPhoto && <img src={pageContent.deanPhoto} className="preview-img" />}
          <div style={{display: 'flex', gap: 10, marginTop: 8}}>
            <label className="upload-label">{uploading && uploadingField === 'deanPhoto' ? '⏳...' : '📷 Upload Photo'}<input type="file" accept="image/*" style={{display:'none'}} onChange={(e) => { if (e.target.files[0]) handleImageUpload('deanPhoto', e.target.files[0]); }} /></label>
            {pageContent.deanPhoto && <button className="remove-btn" onClick={() => deleteImageFromFirebase(pageContent.deanPhoto, 'deanPhoto', false)}>🗑️ Delete</button>}
          </div>
        </div>
        <div className="form-group">
          <label>Dean Message (Rich Text)</label>
          <RichTextEditor 
            value={pageContent.deanMessage || ''}
            onChange={(html) => setPageContent({...pageContent, deanMessage: html})}
            placeholder="Write a message from the Dean..."
            imageFolder="dean-message-images"
          />
        </div>
      </div>

      <style>{`
        .page-editor {
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .editor-card {
          background: #fff;
          border-radius: 16px;
          padding: 24px;
          margin-bottom: 24px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        }
        
        .editor-card h3, .editor-card h4 {
          margin: 0 0 16px;
          color: #1a3a6b;
        }
        
        .editor-card h4 {
          margin-top: 24px;
          border-top: 1px solid #e2e8f0;
          padding-top: 20px;
        }
        
        .form-group {
          margin-bottom: 20px;
        }
        
        .form-group label {
          display: block;
          margin-bottom: 8px;
          font-weight: 600;
          color: #334155;
        }
        
        .form-input {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid #cbd5e1;
          border-radius: 8px;
          font-size: 14px;
        }
        
        .upload-label {
          background: #3b82f6;
          color: white;
          padding: 8px 16px;
          border-radius: 8px;
          cursor: pointer;
          font-size: 13px;
          display: inline-block;
        }
        
        .remove-btn {
          background: #ef4444;
          color: white;
          border: none;
          padding: 6px 12px;
          border-radius: 6px;
          cursor: pointer;
          font-size: 12px;
        }
        
        .preview-img {
          width: 120px;
          height: 90px;
          object-fit: cover;
          border-radius: 8px;
          margin-bottom: 8px;
        }
      `}</style>
    </div>
  );
}

export default AboutEditor;